import React from 'react';
import { Clock, CheckCircle2, AlertCircle, Activity, Package } from 'lucide-react';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

const statusConfig = {
  'Recibido': { color: 'bg-slate-500', icon: Package, label: 'Recibido' },
  'En evaluación': { color: 'bg-amber-500', icon: AlertCircle, label: 'En Evaluación' },
  'En procedimiento': { color: 'bg-amber-500', icon: Activity, label: 'En Procedimiento' },
  'En recuperación': { color: 'bg-green-500', icon: Activity, label: 'En Recuperación' },
  'Listo para recoger': { color: 'bg-green-500', icon: CheckCircle2, label: 'Listo para Recoger' },
  'Cerrado': { color: 'bg-slate-400', icon: CheckCircle2, label: 'Cerrado' }
};

export default function Timeline({ updates }) {
  return (
    <div className="relative">
      <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-slate-200"></div>
      
      <div className="space-y-8">
        {updates.map((update, index) => {
          const config = statusConfig[update.status] || statusConfig['Recibido'];
          const Icon = config.icon;
          
          return (
            <div key={update.id || index} className="relative flex gap-6" data-testid={`timeline-item-${index}`}>
              <div className={`relative z-10 flex items-center justify-center w-8 h-8 rounded-full ${config.color} ring-4 ring-white`}>
                <Icon className="h-4 w-4 text-white" />
              </div>
              
              <div className="flex-1 bg-white rounded-xl border border-slate-200 p-6 shadow-sm">
                <div className="flex items-start justify-between mb-2">
                  <div>
                    <h3 className="font-semibold text-slate-900 text-lg">{config.label}</h3>
                    <div className="flex items-center text-sm text-slate-500 mt-1">
                      <Clock className="h-3.5 w-3.5 mr-1" />
                      {format(new Date(update.created_at), "d 'de' MMMM, HH:mm", { locale: es })}
                    </div>
                  </div>
                  <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${config.color} text-white`}>
                    {config.label}
                  </span>
                </div>
                
                {update.note && (
                  <p className="text-slate-700 mt-3">{update.note}</p>
                )}
                
                {update.images && update.images.length > 0 && (
                  <div className="mt-4 grid grid-cols-2 gap-3">
                    {update.images.map((image, idx) => (
                      <img
                        key={idx}
                        src={image}
                        alt={`Actualización ${idx + 1}`}
                        className="rounded-lg w-full h-48 object-cover"
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
